export const CARE_MANAGER_HIDE_NAVBAR_PREFIXES = ["/care-manager", "/care-manager/messenger"];

export const CARE_MANAGER_SIDEBAR_ITEMS = [
  { to: "/care-manager/onboarding", label: "Onboarding status", icon: "shield" },
  { to: "/care-manager/dashboard", label: "Dispatcher hub", icon: "home" },
  { to: "/care-manager", label: "My cases", end: true, icon: "list" },
  { to: "/care-manager/messenger", label: "Messenger", icon: "message" },
  { to: "/care-manager/assessments", label: "Assessments", icon: "clipboard" },
  { to: "/care-manager/care-plans", label: "Care plans", icon: "list" },
  { to: "/care-manager/marketplace", label: "Marketplace", icon: "search" },
  { to: "/care-manager/profile", label: "Clinical profile", icon: "user" },
  { to: "/care-manager/documents", label: "Documents", icon: "document" },
  { to: "/care-manager/care-logs", label: "Care logs", icon: "clock" },
  { to: "/care-manager/exceptions", label: "Exceptions", icon: "alert" },
  { to: "/care-manager/replacements", label: "Replacements", icon: "alert" },
  { to: "/care-manager/subscription", label: "Subscription", icon: "shield" },
];

export const CARE_MANAGER_USER_META = {
  initials: "",
  name: "",
  role: "Care Manager",
};
